import conicEqualArea from "./conicEqualArea";

export default function() {
  return conicEqualArea()
      .parallels([29.5, 45.5])
      .scale(1070)
      .translate([480, 250])
      .rotate([96, 0])
      .center([-0.6, 38.7]);
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-geo/src/projection/albers.js
// module id = 133
// module chunks = 0